module.exports = __webpack_public_path__ + "img/08.2d09d5a0.jpg";